var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSettings = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "setting-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.75 28.4375C23.2375 28.4375 22.8125 28.0125 22.8125 27.5V13.75C22.8125 13.2375 23.2375 12.8125 23.75 12.8125C24.2625 12.8125 24.6875 13.2375 24.6875 13.75V27.5C24.6875 28.0125 24.2625 28.4375 23.75 28.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.75 9.6875C23.2375 9.6875 22.8125 9.2625 22.8125 8.75V2.5C22.8125 1.9875 23.2375 1.5625 23.75 1.5625C24.2625 1.5625 24.6875 1.9875 24.6875 2.5V8.75C24.6875 9.2625 24.2625 9.6875 23.75 9.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15 28.4375C14.4875 28.4375 14.0625 28.0125 14.0625 27.5V21.25C14.0625 20.7375 14.4875 20.3125 15 20.3125C15.5125 20.3125 15.9375 20.7375 15.9375 21.25V27.5C15.9375 28.0125 15.5125 28.4375 15 28.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15 17.1875C14.4875 17.1875 14.0625 16.7625 14.0625 16.25V2.5C14.0625 1.9875 14.4875 1.5625 15 1.5625C15.5125 1.5625 15.9375 1.9875 15.9375 2.5V16.25C15.9375 16.7625 15.5125 17.1875 15 17.1875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.25 28.4375C5.7375 28.4375 5.3125 28.0125 5.3125 27.5V13.75C5.3125 13.2375 5.7375 12.8125 6.25 12.8125C6.7625 12.8125 7.1875 13.2375 7.1875 13.75V27.5C7.1875 28.0125 6.7625 28.4375 6.25 28.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.25 9.6875C5.7375 9.6875 5.3125 9.2625 5.3125 8.75V2.5C5.3125 1.9875 5.7375 1.5625 6.25 1.5625C6.7625 1.5625 7.1875 1.9875 7.1875 2.5V8.75C7.1875 9.2625 6.7625 9.6875 6.25 9.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M8.75 14.6875H3.75C3.2375 14.6875 2.8125 14.2625 2.8125 13.75C2.8125 13.2375 3.2375 12.8125 3.75 12.8125H8.75C9.2625 12.8125 9.6875 13.2375 9.6875 13.75C9.6875 14.2625 9.2625 14.6875 8.75 14.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M26.25 14.6875H21.25C20.7375 14.6875 20.3125 14.2625 20.3125 13.75C20.3125 13.2375 20.7375 12.8125 21.25 12.8125H26.25C26.7625 12.8125 27.1875 13.2375 27.1875 13.75C27.1875 14.2625 26.7625 14.6875 26.25 14.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M17.5 17.1875H12.5C11.9875 17.1875 11.5625 16.7625 11.5625 16.25C11.5625 15.7375 11.9875 15.3125 12.5 15.3125H17.5C18.0125 15.3125 18.4375 15.7375 18.4375 16.25C18.4375 16.7625 18.0125 17.1875 17.5 17.1875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_10",
    opacity: 0
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSettings);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/settings.cafb06ecf05930c7a8f066064547b96f.svg";